import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/pipes/pipes.module';
import { ContentDividerComponent } from './content-divider/content-divider.component';
import { ContentHeaderItemComponent } from './content-header-item/content-header-item.component';
import { CountryCodePickerComponent } from './country-picker/country-code-picker/country-codes-picker.component';
import { CountryPickerComponent } from './country-picker/country-selector.component';
import { CustomModalComponent } from './custom-modal/custom-modal.component';
import { HelpPopoverComponent } from './help-popover/help-popover.component';
import { ImageTitleComponent } from './image-title/image-title.component';
import { LanguagePickerComponent } from './language-picker/language-picker.component';
import { LocationPickerComponent } from './location-picker/location-picker.component';
import { MainHeaderIconComponent } from './main-header-icon/main-header-icon.component';
import { NativeVersionInfoComponent } from './native-version-info/native-version-info.component';
import { PhoneTypePickerComponent } from './phone-type-picker/phone-type-picker.component';
import { UploadProgressComponent } from './upload-progress/upload-progress.component';
import { ScorePickerComponent } from './score-picker/score-picker.component';
import { StatePickerComponent } from './state-picker/state-picker.component';
import { DatetimePickerComponent } from './datetime-picker/datetime-picker.component';
import { CustomLocationPickerComponent } from './custom-location-picker/custom-location-picker.component';
import { CategoriesPickerComponent } from './categories-picker/categories-picker.component';
import { GmbService } from '@boxx/gmb-core/lib/services/gmb.service';
import { CustomDatetimePickerComponent } from './custom-datetime-picker/custom-datetime-picker.component';
import { CustomDatePopoverComponent } from './custom-date-popover/custom-date-popover.component';
import { CustomTimePopoverComponent } from './custom-time-popover/custom-time-popover.component';
import { CustomCategoryPickerComponent } from './custom-category-picker/custom-category-picker.component';
import { CustomCountryPickerComponent } from './custom-country-picker/custom-country-picker.component';
import { CustomLanguagePickerComponent } from './custom-language-picker/custom-language-picker.component';
import { CustomLocationMapsPickerComponent } from './custom-location-maps-picker/custom-location-maps-picker.component';
import { CustomGenericPickerComponent } from './custom-generic-picker/custom-generic-picker.component';
import { QRComponent } from '@app/pages/home/components/qr/qr.component';
import { DatetimeNotificationsPickerComponent } from './datetime-notifications/datetime-notifications-picker.component';
import { CustomThemePickerComponent } from './custom-theme-picker/custom-theme-picker.component';
import { ImageDetailComponent } from './image-detail/image-detail.component';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    PipesModule,
    TranslateModule.forChild(),
  ],
  declarations: [
    // ------ GENERAL-CONTENT COMPONENTS:
    MainHeaderIconComponent,
    ImageTitleComponent,
    ContentHeaderItemComponent,
    CountryPickerComponent,
    CountryCodePickerComponent,
    ContentDividerComponent,
    CustomModalComponent,
    CustomThemePickerComponent,
    StatePickerComponent,
    LanguagePickerComponent,
    LocationPickerComponent,
    CustomLocationPickerComponent,
    ScorePickerComponent,
    CategoriesPickerComponent,
    PhoneTypePickerComponent,
    UploadProgressComponent,
    HelpPopoverComponent,
    NativeVersionInfoComponent,
    DatetimePickerComponent,
    CustomDatetimePickerComponent,
    DatetimeNotificationsPickerComponent,
    CustomDatePopoverComponent,
    CustomTimePopoverComponent,
    CustomCategoryPickerComponent,
    CustomCountryPickerComponent,
    CustomLanguagePickerComponent,
    CustomLocationMapsPickerComponent,
    CustomGenericPickerComponent,
    QRComponent,
    ImageDetailComponent
  ],
  exports: [
    // ------ GENERAL-CONTENT COMPONENTS:
    MainHeaderIconComponent,
    ImageTitleComponent,
    ContentHeaderItemComponent,
    ContentDividerComponent,
    CustomModalComponent,
    CustomThemePickerComponent,
    CountryPickerComponent,
    StatePickerComponent,
    CountryCodePickerComponent,
    LanguagePickerComponent,
    LocationPickerComponent,
    CustomLocationPickerComponent,
    ScorePickerComponent,
    CategoriesPickerComponent,
    PhoneTypePickerComponent,
    UploadProgressComponent,
    HelpPopoverComponent,
    NativeVersionInfoComponent,
    DatetimePickerComponent,
    CustomDatetimePickerComponent,
    DatetimeNotificationsPickerComponent,
    CustomDatePopoverComponent,
    CustomTimePopoverComponent,
    CustomCategoryPickerComponent,
    CustomCountryPickerComponent,
    CustomLanguagePickerComponent,
    CustomLocationMapsPickerComponent,
    CustomGenericPickerComponent,
    QRComponent,
    ImageDetailComponent
  ],
  providers: [GmbService],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedComponentsModule {
  static forRoot(
    config: ModuleOptionsInterface
  ): ModuleWithProviders<SharedComponentsModule> {
    return {
      ngModule: SharedComponentsModule,
      providers: [...config.providers],
    };
  }
}
